import { render } from "./Panel.vue?vue&type=template&id=ad32c2c0&scoped=true&ts=true"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=ad32c2c0&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad32c2c0"]])

export default __exports__